import globalEventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineeringModulesHeader';

export default {
  created() {
    this.initInstallationAcessListener();
  },
  beforeDestroy() {
    this.removeInstallationAcessListener();
  },
  methods: {
    initInstallationAcessListener() {
      globalEventBus.on(events.info, this.openInstallationWindow, this);
    },
    removeInstallationAcessListener() {
      globalEventBus.off(events.info, this.openInstallationWindow, this);
    },
    openInstallationWindow() {
      const { installationId, assetId } = this.$route.params;

      const routeData = this.$router.resolve({
        name: 'monitoring.asset-information.registration-data',
        params: {
          installationId,
          assetId,
        },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
